import script from "./text-block.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-block.vue?vue&type=script&setup=true&lang=ts"

import "./text-block.vue?vue&type=style&index=0&id=a283865a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a283865a"]])

export default __exports__